import { IntegrationType } from 'server/mpsklad_core/Entity/IntegrationType'
import { integrationTypeNames } from 'types/integrationTypeUtils'
import { CategoryAttributeModel } from '../../../../server/mpsklad_core/Models/MpCard/CategoryAttributeModel'
import { Box, Grid, Typography } from '@material-ui/core'
import { AttributeField } from './attributeField'
import { makeStyles } from '@material-ui/core/styles'
import { BoxLoader } from '../../../../components/BoxLoader'

interface MarketplaceAttributesProps {
  integrationType: IntegrationType,

  fields: (CategoryAttributeModel & {_id: string})[],

  loading: boolean,

  fieldFormName: string,
}

export const MarketplaceAttributesBlock = ({
                                             integrationType,
                                             fields,
                                             loading,
                                             fieldFormName
                                           }: MarketplaceAttributesProps) => {
  const classes = useStyles()

  return (loading || fields.length > 0) ? (
    <>
      <Typography variant="h1" color="primary" gutterBottom className={classes.title}>
        {integrationTypeNames[integrationType]}
      </Typography>
      {loading ? (
        <Box className={classes.loaderWrapper}><BoxLoader/></Box>
      ) : (
         <Grid container spacing={2} className={classes.gridContainer}>
           {fields.map((attr, index) => (
             <Grid item xs={6} key={attr._id}>
               <AttributeField attr={attr} name={`${fieldFormName}.${index}.currentValue`}
                               as={attr.enumValues?.length > 0 ? 'autoselect' : 'input'}/>
             </Grid>
           ))}
         </Grid>
       )}
    </>
  ) : null
}

const useStyles = makeStyles(
  {
    title: {fontWeight: 600, fontSize: '19px', margin: '40px 0 20px 0'},
    gridContainer: {marginBottom: '20px'},
    loaderWrapper: {display: 'flex', alignItems: 'center', justifyContent: 'center'}
  })
